import * as React from "react";

import { cn } from "@/lib/utils";

/**
 * <Surface> — плоская chrome-карточка с обводкой `var(--rule-line)`,
 * фоном `var(--bg-panel-0)` и радиусом `var(--radius-card)`.
 *
 * Один knob на радиус — `--radius-card` в `frontend/src/styles/tokens.css`.
 * См. `docs/frontend/patterns.md` §«Карточка-сурфейс».
 *
 * NB: shadcn `Card` — это «Surface + готовая шапка»: тот же `--radius-card`,
 * тот же фон и та же обводка `var(--rule-line)`. Не другой визуальный язык
 * (ни drop-shadow, ни `rounded-xl`); отличие только в наличии готового
 * `CardHeader` / `CardTitle` / `CardContent`-каркаса.
 */
export function Surface({ className, ...props }: React.ComponentProps<"div">): React.ReactElement {
  return <div data-slot="surface" className={cn("card-surface", className)} {...props} />;
}
